import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'

export const TextHeaderIt = () => {
    return (
        <HighlightedText
            text="RICHIEDI IL TUO BONUS"
            highlights={[{ word: 'TUO' }, { word: 'BONUS' }]}
            className={styles.text_header}
        />
    )
}

export const TextContentIt = () => {
    return (
        <HighlightedText
            text="bonus del 325% + 400 GIRI GRATUITI"
            highlights={[{ word: '325%' }, { word: '+' }, { word: '400' }]}
            breakBeforeWords={['400']}
            className={styles['text_content--FOURTH']}
        />
    )
}
